import { createSlice } from "@reduxjs/toolkit"

const RequestPageSlice = createSlice({
  name: "Request",
  initialState: {

    bulkApprovalReject: {
      bulkApproval: true,
      approve: false,
    },
  },

  reducers: {
    setRequestPage: (state, action) => ({
      ...state,
      bulkApprovalReject: action.payload,
    }),
  },
})

export const { setRequestPage } =
  RequestPageSlice.actions

export default RequestPageSlice.reducer
